import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getCustomMessages,
    getMessagesParameter,
    MessageCollectionModel,
} from "@tKgpco/Services/LoadMessageCollection";

type HandlerType = ApiHandler<getMessagesParameter, MessageCollectionModel[]>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCustomMessages(props.apiParameter);
};

export const DispatchCompleteLoadRMAMessages: HandlerType = props => {
    props.dispatch({
        type: "Custom/RMA/CompleteLoadRMAMessages",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadRMAMessages];

const loadRMAMessages = createHandlerChainRunner(chain, "loadRMAMessages");
export default loadRMAMessages;
